/**
 * 销毁 Modal 实例数组
 */
const destroyFns: Array<any> = [];
export default destroyFns;
